(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('CollectionSearch', CollectionSearch);

    CollectionSearch.$inject = ['$resource'];

    function CollectionSearch($resource) {
        var resourceUrl =  'api/_search/collections/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
